import React from "react";

// 3rd-party
import {IoMdPlay} from "react-icons/io";
import moment from "moment";

// Redux
import {useSelector, useDispatch} from "react-redux";

// Reeler components
import ReelerTooltip from "../../components/commons/ReelerTooltip/ReelerTooltip";

// styles

import * as S from "../../components/campaigns/campaign/components/styles";

// Utils
import {timeAgo} from "../../utils/CalculateTimeAgo";
import {ASSET_STATE, IMG_SIZES, MEDIA_TYPE} from "../../constants";
import AssetStatus from "../../components/campaigns/campaign/components/asset-info/components/AssetStatus";
import MediaType from "../../components/commons/MediaType";
import {selectBulkEditArray} from "../../redux/bulk-edit/bulkEdit.selectors";
import AssetBulkEdit from "../../components/campaigns/campaign/components/AssetBulkEdit";
import {FaCheck, FaTimes} from "react-icons/fa";

const DeletedAsset = ({asset, disableBulkEdit = false}) => {
  const dispatch = useDispatch();
  const assetArray = useSelector(selectBulkEditArray);

  return asset ? (
    <S.AssetPreviewContainer
      selected={assetArray.find((item) => item.id === asset.id)}
      style={{cursor: "default"}}
    >
      <S.TopLeft>
        <AssetBulkEdit asset={asset} />
      </S.TopLeft>

      <S.TopRight>
        <AssetStatus asset={asset} />
      </S.TopRight>

      <S.AssetMediaPreviewContainer>
        {asset.media_type === MEDIA_TYPE.VIDEO ? (
          <S.AssetMediaTypeVideoPlayIcon>
            <IoMdPlay size="2.5rem" />
          </S.AssetMediaTypeVideoPlayIcon>
        ) : null}

        <MediaType
          asset={asset}
          objectFit="contain"
          imgSize={IMG_SIZES.thumb}
          showVideoControls={false}
        />
      </S.AssetMediaPreviewContainer>
      <S.AssetPreviewFooter>
        <ReelerTooltip
          text={`Deleted on ${moment(asset.deletedAt.toDate()).format(
            "YYYY-MM-DD"
          )}`}
        >
          <span
            style={{
              alignSelf: "center",
              fontSize: "12px",
            }}
          >
            {asset?.deletedAt &&
              !isNaN(asset?.deletedAt) &&
              timeAgo(asset?.deletedAt.toDate())}
          </span>
        </ReelerTooltip>

        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "20px",
              height: "20px",

              background:
                asset.state === ASSET_STATE.approved
                  ? "var(--reeler-super-light)"
                  : asset.state === ASSET_STATE.rejected
                  ? "var(--reeler-danger-light)"
                  : "var(--reeler-grey-middle)",
            }}
          >
            {asset.state === ASSET_STATE.approved ? (
              <FaCheck style={{color: "var(--reeler-dark-green)"}} />
            ) : asset.state === ASSET_STATE.rejected ? (
              <FaTimes style={{color: "var(--reeler-danger)"}} />
            ) : null}
          </div>
        </div>
      </S.AssetPreviewFooter>
    </S.AssetPreviewContainer>
  ) : null;
};

export default DeletedAsset;
